export default "__VITE_ASSET__CCsKKpmV__"